// extracted by mini-css-extract-plugin
export default {"information_details_sec":"userform_information_details_sec__6g-aq"};